import axios from '../../helpers/axios'
import { logError } from '../../services';
import { IDropdownResponse } from '../../models';

const base = `/api/admin/lookup`;
export const getAdminLookupAttorneyOffices = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/attorney-offices`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupAttorneyOffices failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupClientSources = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/client-sources`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupClientSources failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupClientStatuses = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/client-statuses`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupClientStatuses failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupCountiesByStateAbbreviation = async (
  stateAbbreviation: string
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/counties/${stateAbbreviation}`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupCountiesByStateAbbreviation failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupNeighborhoods = async (
  isActive: boolean = null,
   allNeighborhoods?: boolean
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/neighborhoods`, { params: { isActive, allNeighborhoods } });

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupNeighborhoods failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupPlanStyles = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/plan-styles`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupPlanStyles failed');
    return Promise.reject(error?.response?.data);
  }
};

// This would normally be an HttpGet, but the list of selected neighborhoods can be too long for query parameters
export const getAdminLookupPlanStylesForSelectedNeighborhoods = async (post: {
  neighborhoodIds: number[];
}): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.post(`${base}/plan-styles-selected-neighborhoods/`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'getAdminLookupPlanStylesForSelectedNeighborhoods failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const getAdminLookupPlaceOrderRoles = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/place-order-roles`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupPlaceOrderRoles failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupStandardFeatures = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/standard-features`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupStandardFeatures failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupStandardFeatureSetSelections = async (
  standardFeatureOptionSetId: number
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `${base}/standard-feature-set-selections/${standardFeatureOptionSetId}`
    );

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupStandardFeatureSetSelections failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupTerritories = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/territories`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupTerritories failed');
    return Promise.reject(error?.response?.data);
  }
};
